import { useEffect, useState } from "react";
import { isBrowser, getDefaultScrollConfig } from "../helpers";

const listenerConfig = getDefaultScrollConfig();

export const DEFAULT_WINDOW_WIDTH = 1280;
export const DEFAULT_WINDOW_HEIGHT = 1024;

export type TViewportSizes = {
  viewportWidth: number;
  viewportHeight: number;
};

export function getWindowDimensions(): TViewportSizes {
  const { innerWidth: viewportWidth, innerHeight: viewportHeight } = window;
  return {
    viewportWidth,
    viewportHeight,
  };
}

export default function useWindowDimensions(): TViewportSizes {
  const [windowDimensions, setWindowDimensions] = useState(() =>
    isBrowser()
      ? getWindowDimensions()
      : {
          viewportWidth: DEFAULT_WINDOW_WIDTH,
          viewportHeight: DEFAULT_WINDOW_HEIGHT,
        },
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize, listenerConfig);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
